<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.statusId"
    item-text="statusNome"
    item-name="statusNome"
    item-value="statusId"
    :items="statusRelacionamento"
    label="Status"
    placeholder="Status"
    v-on:change="$emit('onChange', filter.statusId)"
    :clearable="true"
    :multiple="isMultiple ? true : false"
    :return-object="isMultiple ? true : false"
  >
    <template slot="no-data">
      Nenhum Status de Relacionamento retornado
    </template>
  </v-select>
</template>

<script>
import { StatusRelacionamentoApi } from "../API/StatusRelacionamentoApi.js";

export default {
  name: "AppStatusCombobox",
  props: ["filter", "isMultiple"],
  mounted() {
    this.loadStatus();
  },
  methods: {
    loadStatus() {
      StatusRelacionamentoApi.list()
        .then((resp) => {
          this.statusRelacionamento = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      statusRelacionamento: [],
    };
  },
};
</script>
